import styles from "./TermsAndConditions.module.css";

const SwiftTandC = () => {
  return (
    <>
      <ol className={styles.numberedList}>
        <li>
          The operations on the account is limited to a maximum single deposit
          amount of N50,000 and maximum cumulative balance of 300,000 at any
          point in time
        </li>
        <li>
          Mobile banking is limited to a maximum transaction limit of N3,000 and
          daily limit of N30,000
        </li>
        <li>International funds transfer is prohibited</li>
        <li>
          You will be required to provide further documents at any point in time
          when transaction above the regulated threshold
        </li>
        <li>This account is strictly savings</li>
      </ol>
      <p>
        In consideration of opening and maintaining an account with The
        Alternative NIB and the issuance of a debit card linked to the account,
        I/We hereby understand and agree as follows:
      </p>
      <ol className={`${styles.romanNumeralsList} ${styles.italics}`}>
        <li>
          The Bank does not seek any information relating to my/our full debit
          card PAN, CVV and Personal Identification Number (PIN), or other
          security information regarding my account or debit card.
        </li>
        <li>
          I/We are responsible for the security and safekeeping of my/our debit
          card, including my/our PIN, card PAN, etc.
        </li>
        <li>
          I/We shall not disclose any sensitive information regarding my/our
          account(s) or debit card to unauthorized parties through ant medium
          including but not limited to the internet, text messages, e-mail or
          telephone.
        </li>
        <li>
          I/We shall take all precautions to protect my/our account/debit card
          details to avoid any unauthorized use of the debit card or other
          account details.
        </li>
        <li>
          All transactions or actions initiated, authenticated and consummated
          on my/our account using the debit card are deemed initiated by me/us.
        </li>
      </ol>
      <p className={styles.italics}>
        I/We, ......................................................... hereby
        irrevocably and unconditionally indemnify and keep the Bank fully
        indemnified against all claims, demands, liabilities, damages, loss,
        costs, charges, fees, expenses, distress, actions and proceedings which
        may be brought against the Bank or which the Bank may pay or incur in
        connection with or arising from any litigation or claim against the Bank
        in consequence of renewing and dispatching our debit card to me/us.
      </p>
      <h5>
        <strong>Customer’s Information </strong>
      </h5>
      <ul className={styles.tncList}>
        <li>
          I/We hereby apply for the opening of an account(s) with The
          Alternative Bank Plc. I/We understand that the information given
          herein and the documents supplied are the basis for opening such
          account(s), and hereby warrant that such information is correct. I/We
          further confirm that the account type and/or E-services was duly
          selected by me/us after due consideration of the Bank’s professional
          advice.
        </li>
        <li>
          I/We authorize The Alternative Bank Plc to disclose relevant account
          and/or personal information to the US tax authorities and other
          relevant tax authorities of jurisdictions where I am tax resident for
          the purpose of The Alternative Bank Plc complying with its obligations
          under the US Foreign Account Tax Compliance Act (FATCA) and/or Common
          Reporting Standard (CRS). I declare that I have examined the
          information on this form and to the best of my knowledge and belief,
          it is true, correct, and complete. If the information provided in this
          form changes, I undertake to provide The Alternative Bank with an
          updated self-certification and declaration within 30 days of such
          change.
        </li>
        <li>
          I/We, the undersigned applicant, warrant that the above information
          supplied by me/us is true and correct. I/We will undertake to fully
          cooperate with The Alternative Bank Plc to ensure it meets its
          obligations under FATCA and CRS in connection with my/our account.
        </li>
        <li>
          I/We will indemnify and hold harmless The Alternative Bank Plc from
          any loss, action, cost, expense (including, but not limited to sums
          paid in settlement of claims, reasonable attorneys’ and consultant
          fees, and expert fees), claim, damages, or liability which arises or
          is incurred by The Alternative Bank Plc as a result of false
          information or error in the information provided to the Bank, our
          choice of account, or in discharging its obligations under FATCA and
          CRS and/or as a result of disclosures to the US tax authorities and/or
          any other jurisdictions under the AEOI regime.
        </li>
      </ul>
      <h5>
        <strong>Data Capture & Usage</strong>
      </h5>
      <p className={styles.italics}>
        "By using our services, you consent to the collection, processing, and
        storage of your personal data, including biometric information where
        applicable. This data will be used solely for identity verification,
        security, regulatory compliance, and service improvement. We are
        committed to handling your information securely and in accordance with
        applicable data protection laws."
      </p>
    </>
  );
};

export default SwiftTandC;
